import { render, staticRenderFns } from "./SFootprint.vue?vue&type=template&id=077d432c&scoped=true"
import script from "./sFootprint.ts?vue&type=script&lang=ts&external"
export * from "./sFootprint.ts?vue&type=script&lang=ts&external"
import style0 from "./SFootprint.vue?vue&type=style&index=0&id=077d432c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077d432c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('077d432c')) {
      api.createRecord('077d432c', component.options)
    } else {
      api.reload('077d432c', component.options)
    }
    module.hot.accept("./SFootprint.vue?vue&type=template&id=077d432c&scoped=true", function () {
      api.rerender('077d432c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-footprint/SFootprint.vue"
export default component.exports